module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_message-dd5471c7afc359f6f3ce36891b63bda2.svg";